module.exports = __webpack_public_path__ + "static/media/squared.e3ca2cd0.jpg";